export const HouseholdQuestionTypes = {
	HouseHoldMemberList: 'householdMemberList',
	HouseHoldAccountOnboarding: 'householdAccountOnboarding'
};
